import { API_ENDPOINTS } from "@/constants/api";
import { http } from "@/lib/http-client";
import { unwrapData, unwrapPaginated } from "@/lib/api-response";
import { downloadAuthenticatedFile } from "@/lib/download-blob";
import type {
  Backup,
  BackupSchedule,
  CreateBackupRequest,
  ListBackupsQuery,
  RestoreBackupRequest,
} from "@/types/backup";
import type { PaginatedResult } from "@/types/common";

export const backupService = {
  async list(query?: ListBackupsQuery): Promise<PaginatedResult<Backup>> {
    const response = await http.get(API_ENDPOINTS.BACKUPS.LIST, {
      params: query,
    });
    return unwrapPaginated<Backup>(response);
  },

  async create(payload: CreateBackupRequest): Promise<Backup> {
    const response = await http.post(API_ENDPOINTS.BACKUPS.CREATE, payload);
    return unwrapData<Backup>(response);
  },

  async download(id: string): Promise<void> {
    await downloadAuthenticatedFile(
      API_ENDPOINTS.BACKUPS.DOWNLOAD(id),
      undefined,
      `backup-${id}.zip`,
    );
  },

  async restore(id: string, payload: RestoreBackupRequest): Promise<void> {
    await http.post(API_ENDPOINTS.BACKUPS.RESTORE(id), payload);
  },

  async getSchedule(): Promise<BackupSchedule> {
    const response = await http.get(API_ENDPOINTS.BACKUPS.SCHEDULE);
    return unwrapData<BackupSchedule>(response);
  },
};
